import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { isSessionExpired } from '../../util';

export default function ProtectedRoute({ permissions = 0, children }) {
  const location = useLocation();
  // get user
  const { user, loading } = useAuth();

  if (loading)
    return <div>Loading session data...</div>;

  if (!user) {
    // not authenticated, redirect to login page with redirect to current location
    return (
      <Navigate
        to={`/login?redirect=${encodeURIComponent(location.pathname)}`}
        replace
      />
    );
  }

  // missing perms
  if ((user.permissions & permissions) !== permissions) {
    // maybe make this a reusable component idk
    return ( 
      <div className="wrapper">
        <div>
          <h1>Unauthorised</h1>
          <p>You do not have permission to access this resource.</p>
        </div>
      </div>
    )
  }
  
  // all checks passed
  return children;
}